module.exports = __webpack_public_path__ + "static/media/toilet-state-2.b466fcb8.wav";